import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import CatalogsList from 'catalogs/components/list';

import { createRoute } from 'lib/util';

const { Form } = Common;

const CatalogsListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {},
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <CatalogsList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
        canAdd={permissions["acl.catalogs.add"]}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('menu.configuration') + ' > ' + t('catalogs.catalogs_title')}
          icon={'list-ul'}
          button={
            <div className="btn-group pull-right">
              {permissions['acl.catalogs.add'] && (
                <Form.Link
                  to={createRoute(company.id, subcompany.id, 'catalogs/add')}
                  className="btn btn-info"
                >
                  {t('actions.add')}
                </Form.Link>
              )}
            </div>
          }
          buttonTwo={
            <CatalogsList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <CatalogsList.Table
              company={company}
              subcompany={subcompany}
              permissions={permissions}
              handleToggle={handleToggle}
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </CatalogsList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(CatalogsListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/CatalogsListView.js